<template>
  <div class="dtablerow">

    <!-- Left Panel -->
    <aside id="left-panel" class="left-panel">
      <LeftMenu/>
    </aside><!-- /#left-panel -->
    <!-- Left Panel -->

    <!-- Right Panel -->
    <div id="right-panel" class="right-panel">
      <!-- Header-->
      <header id="header" class="header">
        <div class="header-menu">
          <div class="col-sm-7">
            <MenuToggle/>
            <div class="header-left">
              <HeaderSearch/>
              <HeaderCompanySelector/>
              <HeaderNotification/>
              <HeaderMessages/>
            </div>
          </div>
          <div class="col-sm-5">
            <User/>
            <LngChooser/>
          </div>
        </div>
      </header><!-- /header -->
      <!-- Header-->
      <Breadcrumbs/>
      <div class="content mt-3">
        <div class="animated fadeIn" v-if="hasRole&&hasCompany">
          <!-- content place -->
          <div class="col-lg-12">
            <div class="card">


              <!--<div class="card-header">-->
              <!--<strong>{{$t('global.roleproblemnocompanytitle')}}</strong>-->
              <!--<div class="float-right">-->
              <!--</div>-->
              <!--</div>-->
              <div class="card-body card-block">

                <template v-if="pageType===''"><h3 class="mb-3">{{$t('dashboard.organizer.DEFAULT')}}</h3>

                </template>
                <template v-if="pageType==='REDIRECTING'"><h3 class="mb-3">{{$t('dashboard.organizer.REDIRECTING')}}</h3>

                </template>
                <template v-if="pageType==='INVITATION'"><h3 class="mb-3">{{$t('dashboard.organizer.INVITATION')}}</h3>

                </template>
                <template v-if="pageType==='COMPANYDASHBOARD'">
                  <!--{{$t('dashboard.organizer.COMPANYDASHBOARD')}}-->
                  <div class="row">

                  <div class="col-md-6">
                    <aside class="profile-nav alt">
                      <section class="card">
                        <div class="card-header user-header alt bg-dark">
                          <div class="media">
                            <!--<a href="#">-->
                              <!--<img class="align-self-center rounded-circle mr-3" style="width:85px; height:85px;" alt="" src="">-->
                            <!--</a>-->
                            <div class="media-body">
                              <h2 class="text-light display-6">{{$t('dashboard.userData')}}</h2>
                              <!--<p>Project Manager</p>-->
                            </div>
                          </div>
                        </div>


                        <ul class="list-group list-group-flush">
                          <li class="list-group-item">
                            <a href="#"><i class="fa fa-user"></i> </a> {{(state && state.user && state.user.name) ? state.user.name : "-"}}
                          </li>
                          <li class="list-group-item">
                            <a href="#"><i class="fa fa-envelope-o"></i> </a> {{(state && state.user && state.user.email) ? state.user.email : "-"}}
                          </li>
                          <li class="list-group-item">
                            <a href="#"><i class="fa fa-phone"></i> </a> {{(state && state.user && state.user.phone) ? state.user.phone : "-"}}
                          </li>
                          <li v-if="state.user && state.user.id" class="list-group-item">
                            <router-link :to="'/usermyprofile'" class="alert alert-primary">  <i class="fa fa-edit"> </i> {{ $t('global.edit') }}</router-link>
                          </li>

                          <!--<li class="list-group-item">-->
                            <!--<a href="#"> <i class="fa fa-envelope-o"></i> Mail Inbox <span class="badge badge-primary pull-right">10</span></a>-->
                          <!--</li>-->
                          <!--<li class="list-group-item">-->
                            <!--<a href="#"> <i class="fa fa-tasks"></i> Recent Activity <span class="badge badge-danger pull-right">15</span></a>-->
                          <!--</li>-->
                          <!--<li class="list-group-item">-->
                            <!--<a href="#"> <i class="fa fa-bell-o"></i> Notification <span class="badge badge-success pull-right">11</span></a>-->
                          <!--</li>-->
                          <!--<li class="list-group-item">-->
                            <!--<a href="#"> <i class="fa fa-comments-o"></i> Message <span class="badge badge-warning pull-right r-activity">03</span></a>-->
                          <!--</li>-->
                        </ul>

                      </section>
                    </aside>
                  </div>

                  <div class="col-md-6">
                    <aside class="profile-nav alt">
                      <section class="card">
                        <div class="card-header user-header alt bg-dark">
                          <div class="media">
                            <!--<a href="#">-->
                              <!--<img class="align-self-center rounded-circle mr-3" style="width:85px; height:85px;" alt="" src="">-->
                            <!--</a>-->
                            <div class="media-body">
                              <h2 class="text-light display-6">{{$t('dashboard.companyData')}}</h2>
                              <!--<p>Project Manager</p>-->
                            </div>
                          </div>
                        </div>


                        <ul class="list-group list-group-flush">

                          <li class="list-group-item">
                            <a href="#"><i class="fa fa-user"></i> </a> {{(company.company_name) ? company.company_name : ""}}
                          </li>
                          <li class="list-group-item">
                            <a href="#"><i class="fa fa-hospital-o"></i> </a> {{(company.company_taxnumber) ? company.company_taxnumber : ""}}
                          </li>
                          <li class="list-group-item">
                            <a href="#"><i class="fa fa-briefcase"></i> </a> {{(company.company_bank_account) ? company.company_bank_account : ""}}
                          </li>
                          <li v-if="company.id" class="list-group-item">
                            <router-link :to="/company/+company.id" class="alert alert-primary">  <i class="fa fa-edit"> </i> {{ $t('global.edit') }}</router-link>
                          </li>

                          <!--<li class="list-group-item">-->
                            <!--<a href="#"> <i class="fa fa-envelope-o"></i> {{(state && state.user && state.user.name) ? state.user.name : ""}} <span class="badge badge-primary pull-right">10</span></a>-->
                          <!--</li>-->
                          <!--<li class="list-group-item">-->
                            <!--<a href="#"> <i class="fa fa-tasks"></i> Recent Activity <span class="badge badge-danger pull-right">15</span></a>-->
                          <!--</li>-->
                          <!--<li class="list-group-item">-->
                            <!--<a href="#"> <i class="fa fa-bell-o"></i> Notification <span class="badge badge-success pull-right">11</span></a>-->
                          <!--</li>-->
                          <!--<li class="list-group-item">-->
                            <!--<a href="#"> <i class="fa fa-comments-o"></i> Message <span class="badge badge-warning pull-right r-activity">03</span></a>-->
                          <!--</li>-->
                        </ul>

                      </section>
                    </aside>
                  </div>

                  </div>

                </template>
                <template v-if="pageType==='WELCOME'"><h3 class="mb-3">{{$t('dashboard.organizer.WELCOME')}}</h3>

                  <div class="row">

                  <div class="col-md-6">
                    <aside class="profile-nav alt">
                      <section class="card">
                        <div class="card-header user-header alt bg-dark">
                          <div class="media">
                            <!--<a href="#">-->
                            <!--<img class="align-self-center rounded-circle mr-3" style="width:85px; height:85px;" alt="" src="">-->
                            <!--</a>-->
                            <div class="media-body">
                              <h2 class="text-light display-6">{{$t('dashboard.userData')}}</h2>
                              <!--<p>Project Manager</p>-->
                            </div>
                          </div>
                        </div>


                        <ul class="list-group list-group-flush">
                          <li class="list-group-item">
                            <a href="#"><i class="fa fa-user"></i> </a> {{(state && state.user && state.user.name) ? state.user.name : "-"}}
                          </li>
                          <li class="list-group-item">
                            <a href="#"><i class="fa fa-envelope-o"></i> </a> {{(state && state.user && state.user.email) ? state.user.email : "-"}}
                          </li>
                          <li class="list-group-item">
                            <a href="#"><i class="fa fa-phone"></i> </a> {{(state && state.user && state.user.phone) ? state.user.phone : "-"}}
                          </li>

                          <!--<li class="list-group-item">-->
                          <!--<a href="#"> <i class="fa fa-envelope-o"></i> Mail Inbox <span class="badge badge-primary pull-right">10</span></a>-->
                          <!--</li>-->
                          <!--<li class="list-group-item">-->
                          <!--<a href="#"> <i class="fa fa-tasks"></i> Recent Activity <span class="badge badge-danger pull-right">15</span></a>-->
                          <!--</li>-->
                          <!--<li class="list-group-item">-->
                          <!--<a href="#"> <i class="fa fa-bell-o"></i> Notification <span class="badge badge-success pull-right">11</span></a>-->
                          <!--</li>-->
                          <!--<li class="list-group-item">-->
                          <!--<a href="#"> <i class="fa fa-comments-o"></i> Message <span class="badge badge-warning pull-right r-activity">03</span></a>-->
                          <!--</li>-->
                        </ul>

                      </section>
                    </aside>
                  </div>

                  <div class="col-md-6">
                    <aside class="profile-nav alt">
                      <section class="card">
                        <div class="card-header user-header alt bg-dark">
                          <div class="media">
                            <!--<a href="#">-->
                            <!--<img class="align-self-center rounded-circle mr-3" style="width:85px; height:85px;" alt="" src="">-->
                            <!--</a>-->
                            <div class="media-body">
                              <h2 class="text-light display-6">{{$t('dashboard.companyData')}}</h2>
                              <!--<p>Project Manager</p>-->
                            </div>
                          </div>
                        </div>


                        <ul class="list-group list-group-flush">

                          <li class="list-group-item">
                            <a href="#"><i class="fa fa-user"></i> </a> {{(company.company_name) ? company.company_name : ""}}
                          </li>
                          <li class="list-group-item">
                            <a href="#"><i class="fa fa-hospital-o"></i> </a> {{(company.company_taxnumber) ? company.company_taxnumber : ""}}
                          </li>
                          <li class="list-group-item">
                            <a href="#"><i class="fa fa-briefcase"></i> </a> {{(company.company_bank_account) ? company.company_bank_account : ""}}
                          </li>

                          <!--<li class="list-group-item">-->
                          <!--<a href="#"> <i class="fa fa-envelope-o"></i> {{(state && state.user && state.user.name) ? state.user.name : ""}} <span class="badge badge-primary pull-right">10</span></a>-->
                          <!--</li>-->
                          <!--<li class="list-group-item">-->
                          <!--<a href="#"> <i class="fa fa-tasks"></i> Recent Activity <span class="badge badge-danger pull-right">15</span></a>-->
                          <!--</li>-->
                          <!--<li class="list-group-item">-->
                          <!--<a href="#"> <i class="fa fa-bell-o"></i> Notification <span class="badge badge-success pull-right">11</span></a>-->
                          <!--</li>-->
                          <!--<li class="list-group-item">-->
                          <!--<a href="#"> <i class="fa fa-comments-o"></i> Message <span class="badge badge-warning pull-right r-activity">03</span></a>-->
                          <!--</li>-->
                        </ul>

                      </section>
                    </aside>
                  </div>

                  </div>

                </template>

              </div>
            </div>
          </div>

          <!-- You are eligible for at least one module -  Legalább egynél több modulhoz van joga-->


          <!--<template v-if="moduleRightsIds.indexOf('1')>-1">-->
          <!--<CloudDashboard/>-->
          <!--<SelDashboard v-if="Helper.checkRolesAuto(this, [1,10, 11],6)" />-->
          <!--</template>-->


        </div><!-- .animated -->

        <div class="animated fadeIn" v-if="!this.hasCompany">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemnocompanytitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemnocompany')}}</div>
            </div>
          </div>
        </div><!-- .animated -->

      </div><!-- .content -->
    </div><!-- /#right-panel -->
    <!-- Right Panel -->
  </div>
</template>

<script>
  // @ is an alias to /src
  import LeftMenu from '@/components/LeftMenu.vue';
  import HeaderSearch from '@/components/HeaderSearch.vue';
  import HeaderCompanySelector from '@/components/HeaderCompanySelector.vue';
  import HeaderNotification from '@/components/HeaderNotification.vue';
  import HeaderMessages from '@/components/HeaderMessages.vue';
  import User from '@/components/User.vue';
  import LngChooser from '@/components/LngChooser.vue';
  import Breadcrumbs from '@/components/Breadcrumbs.vue';
  import SelDashboard from '@/views/SelDashboard.vue';
  import CloudDashboard from '@/views/CloudDashboard.vue';
  import MenuToggle from '@/components/MenuToggle.vue';
  import Helper from '@/helper/Helper';
  import Api from '@/api/Api';
  import HelperRole from "@/helper/HelperRole";
  //  import HelperRole from '@/helper/HelperRole';
  //  import HelperWatcher from "@/helper/HelperWatcher";
  import TestFunctions from '@/components/TestFunctions.vue';

  export default {
    name: 'Dashboard',
    data(){
      return {
//        user: {},
//        companymodules: [],
//        usercompanies: [],
//        userrolesforcompany: [],
        Helper: Helper,
//        HelperRole: HelperRole,
//        HelperWatcher: HelperWatcher,
        pageType: ""

        , hasRole: false
        , hasCompany: false
        , state: {}
        , company: {}

      }
    },

    watch: {
      "$store.state.user": function (newData, oldData) {
        if (String(newData) !== "" && newData !== oldData) {
          this.handleRights();
          this.makeActualCompany();
        }
      },
      "$store.state.companymodules": function (newData, oldData) {
        if (String(newData) !== "" && newData !== oldData) {
          this.handleRights();
          this.makeActualCompany();
        }
      },
      "$store.state.usercompanies": function (newData, oldData) {
        if (String(newData) !== "" && newData !== oldData) {
          this.handleRights();
          this.makeActualCompany();
        }
      },
      "$store.state.userrolesforcompany": function (newData, oldData) {
        if (String(newData) !== "" && newData !== oldData) {
          this.handleRights();
          this.makeActualCompany();
        }
      },
      "$store.state.healthCheckHash": function (newData, oldData) {
        const modul = this;
        if (newData !== oldData) {
          modul.state = Object.assign({}, modul.$store.state);
          this.handleRights();
          this.makeActualCompany();
        }
      },

    },
    mounted() {
      const modul = this;
      Api.healthCheck({}).then(function (res) {
          HelperRole.healthCheckHandler(modul, res);
        }, function (res) {
          HelperRole.healthCheckHandler(modul, res);
        }
      );
      modul.state = Object.assign({}, modul.$store.state);

    },
    methods: {

      handleRights(){
        const modul = this;
        if (modul.$store.state.user) {
          modul.hasRole = true;
        }
        if (modul.$store.state.id_company) {
          modul.hasCompany = true;
          if (modul.$store.state.user.id_company) {
            const id = modul.$store.state.user.id_company;
            modul.getMyCompany(id);
          }
        }


//      Dashboard:
//        INIT-re egy handle cucc, addig
//      -Üres oldal, hogy a betöltés folyamatban
//      (api már átadott mindent)
//      Ha nincs cég, akkor
        if (modul.$store.state.usercompanies.length === 0) {

          if (modul.$store.state.user.role === "ADMIN") {
//      hA admin VAGYOK,
//        -AKKOR CÉGLISTA
            modul.pageType = "REDIRECTING"
            modul.$router.push({path: "company"})

          } else if (modul.$store.state.user.role === "USER") {
//      hA user VAGYOK
//      -AKKOR KIíRÁS, HOGY HíVJANAK MEG
            modul.pageType = "INVITATION"

          }
        } else if (modul.$store.state.usercompanies.length > 0) {
//      Ha van cég, akkor
          if (modul.$store.state.user.role === "ADMIN") {
//      hA ADMIN VAGYOK,
//        -AKKOR AKTUÁL CÉG DASHBOARD
            modul.pageType = "COMPANYDASHBOARD"

            /*
             user.email
             -user.firstName
             -user.lastName
             user.name
             user.phone


             companymodules.[]
             active=1
             $t(langkey)

             id_company
             */

            console.log(modul.state);

            modul.makeActualCompany();
//            if (modul.state && modul.state.user.id_company) {
//              const id = modul.state.user.id_company;
////              modul.getMyCompany(id);
//            }


          } else if (modul.$store.state.user.role === "USER") {
//      hA user VAGYOK
//      -kÖSZÖNTŐ OLDAL, HOGY VÁLASSZ A MENÜBŐL.(Ezt tovább lehetne cizellálni)
            modul.pageType = "WELCOME"
          }


        }
      },
      makeActualCompany(){
        const modul = this;
        if (modul.state && modul.state.usercompanies && modul.state.usercompanies.length > 0 && modul.state && modul.state.id_company) {
          modul.company = Helper.getObjectByIdFromObjectArray(modul.state.usercompanies, modul.state.id_company)
        }
      },
//      getMyCompany(id){
//        const modul = this;
////        let id = 0;
//        try {
//          if (id) {
//            Api.getMyCompany({id: id, id_company: modul.$store.state.id_company}).then(function (res) {
//              console.log(res);
//              if (res && res.result) {
//                modul.companyData = res.data;
//              }
//            });
//          }
//        } catch (e) {
//          console.log(e);
//        }
//      },
    },

      components: {
        TestFunctions,
        LeftMenu,
        HeaderSearch,
        HeaderCompanySelector,
        HeaderNotification,
        HeaderMessages,
        User,
        LngChooser,
        Breadcrumbs,
//      HelloI18n,
        SelDashboard,
        CloudDashboard,
        MenuToggle
      },
    };
</script>








